/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(function() {
  colorChangeLabel();
  megaMenu();
});
$(window).on('load', function() {
  colorChangeLabel();
});


function colorChangeLabel() {
  $("span.product-label").each(function() {
    let color = "#437dd9"; //デフォルトカラー
    switch($(this).text()) {
      case "お得なセットあり":
        color = "#ee0000";
        break;
      case "人気の商品":
        color = "#0774d7";
        break;
    }
    $(this).css("background-color", color);
  });
}

// 「商品一覧」でページ切り替え時
var observer = new MutationObserver(function(){
  colorChangeLabel();
});
const target = $(".collection > .card");
const config = { 
  attributes: true, 
  childList: true, 
  characterData: true,
  subtree: true
};
$(target).each(function(i) {
  observer.observe(target[i], config);
});

function megaMenu() {
  $('.mega-menu__title').removeAttr('href');
  $(".mega-menu__inner > .mega-menu__column:nth-child(3), .mega-menu__inner > .mega-menu__column:nth-child(4)").wrapAll('<div class="mega-menu__column"></div>');
}
